import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect } from 'react-router-dom'
import { Input, Button, message, Modal } from 'antd'
import { MOBILE_REG, PASSWORD_REG } from '@/constants'
import { getCaptcha, resetPassword, registerMobileCheck, sendSmsCode } from 'request/user'
import LoginCommonFrame from '@/components/container/login-common-frame'

import './style.scss'

function ForgetPassword(props) {
  const [isShowCaptchaDialog, setIsShowCaptchaDialog] = useState(false)
  const [captcha, setCaptcha] = useState('')
  const [registerData, setRegisterData] = useState({ phone: '' })
  const [isPhoneChecked, setIsPhoneChecked] = useState(null)
  const [captchaUrl, setCaptchaUrl] = useState(getCaptcha)
  const [captchaBtnText, setCaptchaBtnText] = useState('获取验证码')
  const [captchaLeftSeconds, setCaptchaLeftSeconds] = useState(0)
  const {isLogin} = props
  useEffect(() => {
    if (captchaLeftSeconds > 0) {
      setCaptchaBtnText(`重新获取(${captchaLeftSeconds}秒)`)
      setTimeout(() => setCaptchaLeftSeconds(captchaLeftSeconds - 1), 1000)
    } else {
      setCaptchaBtnText('获取验证码')
    }
  }, [captchaLeftSeconds])

  useEffect(() => {
    const { phone } = registerData
    if (phone && MOBILE_REG.test(phone)) {
      checkPhone(phone).catch(e => message.error(e.message))
    } else {
      setIsPhoneChecked(null)
    }
  }, [registerData.phone])

  const getSmsCode = async() => {
    const { phone } = registerData
    if (!phone) {
      return message.warn('请输入手机号')
    }
    if (!MOBILE_REG.test(phone)) {
      return message.warn('请输入正确的手机号')
    }
    isPhoneChecked && setIsShowCaptchaDialog(true)
  }

  const checkPhone = async(username) => {
    const { success, message: errMsg, data } = await registerMobileCheck({ username })
    if (!success) {
      return message.error(errMsg)
    }
    setIsPhoneChecked(data && data.exist)
  }

  const sendCode = async() => {
    if (!captcha) {
      return message.warn('请输入验证码')
    }
    const { success, message: errMsg } = await sendSmsCode({ captcha, type: 'RESET_PWD', phone: registerData.phone })
    if (!success) {
      resetCaptcha()
      return message.error(errMsg)
    }
    setCaptchaLeftSeconds(60)
    setIsShowCaptchaDialog(false)
  }

  const resetCaptcha = () => {
    setCaptchaUrl(`${getCaptcha}?t=${new Date().getTime()}`)
  }

  const onSubmit = async() => {
    const { phone, smsCode, password } = registerData
    if (!phone || !isPhoneChecked) {
      return message.warn('请输入正确的手机号')
    }
    if (!smsCode) {
      return message.warn('验证码不能为空')
    }
    if (!PASSWORD_REG.test(password)) {
      return message.warn('8-20位，并且包含大写字母、小写字母、数字和特殊字符中三种及以上组合')
    }
    const { success, message: errMsg } = await resetPassword({ smsCode, password })
    if (!success) {
      return message.error(errMsg)
    }
    message.success('密码重置成功')
    setTimeout(() => {
      props.history.replace('/login')
    }, 2500)
  }

  return (
    isLogin ? <Redirect to="/"/> : (
      <>
        <LoginCommonFrame title="忘记密码">
          <p>
            <Input
              size="large"
              placeholder="请输入手机号"
              onChange={e => setRegisterData({ ...registerData, phone: e.target.value.trim() })}
            />
            {isPhoneChecked === false && (
              <div className="warning-mobile">该手机号未注册，请先注册</div>
            )}
          </p>
          <p style={{ marginBottom: '6px' }}>
            <Input
              size="large"
              placeholder="请输入验证码"
              onChange={e => setRegisterData({ ...registerData, smsCode: e.target.value.trim() })}
              addonAfter={
                <span
                  className="captcha-text" onClick={getSmsCode}
                  style={{ display: 'inline-block', width: '120px', cursor: 'pointer' }}
                >
                  {captchaBtnText}
                </span>
              }
            />
          </p>
          <p>
            <Input.Password
              size="large"
              placeholder="请输入新密码"
              onChange={e => setRegisterData({ ...registerData, password: e.target.value.trim() })}
            />
          </p>
          <p>
            <Button size="large" className="login-btn" type="primary" onClick={onSubmit}>确定</Button>
          </p>
        </LoginCommonFrame>
        {isShowCaptchaDialog && (
          <Modal
            title="获取验证码"
            width="500px"
            visible={isShowCaptchaDialog}
            onCancel={() => setIsShowCaptchaDialog(false)}
            onOk={sendCode}
            okText="确定"
            cancelText="取消"
          >
            <Input
              placeholder="请输入验证码"
              size="large"
              onChange={e => setCaptcha(e.target.value.trim())}
              addonAfter={<span style={{ display: 'inline-block', width: '120px', cursor: 'pointer' }}>
                <img src={captchaUrl} style={{ height: '38px', width: '100%' }} onClick={resetCaptcha} alt="验证码"/>
              </span>}
            />
          </Modal>
        )}
      </>
    )
  )
}

export default connect(state => ({
  isLogin: state.getIn(['common', 'isLogin'])
}))(withRouter(ForgetPassword))
